import React from 'react';
import { useParams } from 'react-router';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import { showToast } from '@/src/globalFunction';

import { useLogActivity } from '../../../../../../api/logActivity';
import { useFileEntryViewerSidebarActions } from '../../../store/fileEntryViewer.sidebarActions.store';

export const getDocumentUrl = ({ projectId, linkId, type, source }) => {
  return (
    window.location.origin +
    `/account#/projects/${projectId}/inbox/${linkId}?type=${type}&source=${source}`
  );
};

type CopyFileUrlProps = {
  fileEntry: FileEntry;
};

const CopyFileUrl = ({ fileEntry }: CopyFileUrlProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const { onFileUrlCopied, onCopyFileUrl } = sidebarActions;
  const logActivityMutation = useLogActivity();

  const handleClick = async () => {
    const documentUrl = onCopyFileUrl();
    const data = [
      {
        linkId: fileEntry.file.id,
        linkType: 'document',
        title: `copied file URL of`,
        actionType: 'copy',
        projectId: projectId,
        activity: `Copied File URL`,
      },
    ];

    navigator.clipboard.writeText(documentUrl);

    const response = await logActivityMutation.mutateAsync({
      data,
      type: 'file',
    });

    if (response) {
      showToast('success', 'File link copied to clipboard.');
    }

    onFileUrlCopied();
  };

  return (
    <ActionButton
      id={'copy_url'}
      onClick={handleClick}
      tooltipSettings={{
        content: 'Copy File URL',
        place: 'left',
      }}
      icon={ICONS.link}
    />
  );
};

export default CopyFileUrl;
